<template>
    <div>
        <div class="content" v-if="is_initialized">
            <div class="title">
                {{ status.name }}
                <span v-if="status.location"> @ {{ status.location }}</span>
            </div>
            {{
                $moment(
                    status.created_at
                ).format('YYYY/MM/DD HH:mm:ss')
            }}
            <div class="staff_name" v-if="is_show_staff">
                <span v-if="status.operator">
                    <span v-if="status.operator.name">
                        {{ status.operator.name }}
                    </span>
                    <span v-else>
                        {{ status.operator.company_short_name }}
                    </span>
                </span>
                <span v-else-if="scope != 'provider'">
                    <span v-if="status.operator">
                        <span v-if="status.operator.name">
                            {{ status.operator.name }}
                        </span>
                        <span v-else>
                            {{ status.operator.company_short_name }}
                        </span>
                    </span>
                    <span v-else>
                        <!-- [系統生成] -->
                        [{{ $t('ui.pages.core_waybills.system_generation') }}]
                    </span>
                </span>
                <span v-else>
                    {{
                        $store.getters['provider/tool_core_waybill_module/get_operator_name'](
                            status.operator_identity
                        ) || '['+$t('ui.pages.core_waybills.system_generation')+']'
                    }}
                </span>
            </div>

            <div class="description">
                {{ status.description }}
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        status: {
            default: {},
            type: Object
        },
        scope: {
            default: 'provider',
            type: String
        },
        is_show_staff: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            staff: {},
        }
    },
    watch: {
        statuses() {
            this.init()
        },
        fetch_staff() {
            this.init()
        },
    },
    created() {
    },
    mounted() {
        this.init()
    },
    computed: {
    },
    methods: {
        async init() {
            this.is_initialized = false
            await new Promise(resolve => {
                this.is_initialized = true
            })
        },
    },
    components: {
    },
}
</script>

<style scoped lang="scss">
    .description {
        position: absolute;
        right: 6px;
        top: 0;
    }
</style>
